import { render, staticRenderFns } from "./high_seas_management.vue?vue&type=template&id=5d2596d6&"
import script from "./high_seas_management.vue?vue&type=script&lang=js&"
export * from "./high_seas_management.vue?vue&type=script&lang=js&"
import style0 from "./high_seas_management.vue?vue&type=style&index=0&id=5d2596d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports